import environment from "../environments/environment";

const ENDPOINTS = {
	OAUTH_TOKEN: (username, password) => 
		'/oauth/token?' + 
		'client_id=' + environment.oauth2_client_id + '&' +  
		'client_secret=' + environment.oauth2_client_secret + '&' +
		'grant_type=password&' +
		'username=' + username + '&' +
		'password=' + password
};

export default ENDPOINTS;